import { Alert } from 'antd'

import { gpuAdminConfigured } from '@/api/gpu/client'

// Renders the reason a GPU page has no data, or nothing when it can load.
export function GpuState({ error }: { error: Error | null }) {
  if (!gpuAdminConfigured) {
    return (
      <Alert
        type="info"
        showIcon
        message="GPU service is not configured"
        description="This environment has no GPU_ADMIN_ENDPOINT in its runtime config."
      />
    )
  }
  if (error) {
    return (
      <Alert
        type="error"
        showIcon
        message="GPU service request failed"
        description={error.message}
      />
    )
  }
  return null
}
